module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-03-770f3dc1191d8c446147532b68172391.jpg";